import { render } from "./MethodologySection.vue?vue&type=template&id=0c97a2e4&scoped=true"
const script = {}

import "./MethodologySection.vue?vue&type=style&index=0&id=0c97a2e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c97a2e4"]])

export default __exports__